module.exports = __webpack_public_path__ + "img/logo.dbb29645.png";